import React from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function Information({ open, close, data, handleApprove }) {
  const Reject = (data) => {
    handleApprove(data, true);
    close(false);
  };

  return (
    // <>TEXTX</>
    <Dialog
      open={open}
      maxWidth="lg"
      fullWidth
      style={{ backdropFilter: "blur(5px)" }}
      PaperProps={{
        sx: { borderRadius: 5, overflow: "hidden" },
      }}
    >
      <IconButton
        edge="end"
        color="inherit"
        onClick={() => close(false)}
        aria-label="close"
        sx={{
          position: "absolute",
          right: 25,
          top: 8,
          //   color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>

      <div
        className="bg-gray-50 py-10 px-2 custom-scrollbar"
        style={{
          //   maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        {/* Header Section */}
        <div className="max-w-5xl mx-auto bg-gradient-to-r from-yellow-500 to-yellow-300 text-white shadow-xl rounded-xl p-8 relative">
          <div className="flex items-center space-x-8">
            <img
              src={data?.image}
              alt={data?.driver_name}
              className="w-32 h-32 rounded-full border-2 border-black shadow-lg"
            />
            <div>
              <h2 className="text-4xl font-extrabold font-Poppins tracking-tight text-black">
                {data?.driver_name}
              </h2>
              <p className="text-md mt-2 text-black font-Poppins">
                Driver ID: {data?.driver_id}
              </p>
              <p className="text-md mt-1 text-black font-Poppins">
                Mobile: {data?.mobile_number}
              </p>
              <p className="text-md mt-1 text-black font-Poppins">
                Rating: <span className="text-green-500">⭐</span>{" "}
                {data?.rating}
              </p>
            </div>
          </div>
        </div>

        {/* Driver Details */}
        <DetailsSection title="Driver Details">
          <DetailRow label="Date of Birth" value={formatDate(data?.dob)} />
          {/* <DetailRow label="Father's Name" value={data?.fathername} /> */}
          {/* <DetailRow label="Father's Number" value={data?.fathernumber} /> */}
          <DetailRow label="Emergency Contact" value={data?.emergency_number} />
          <DetailRow label="Blood Group" value={data?.blood_group} />
          <DetailRow label="Experience" value={`${data?.experience} years`} />
          <DetailRow label="Height" value={`${data?.height} cm`} />
          <DetailRow label="Weight" value={`${data?.weight} kg`} />
        </DetailsSection>

        {/* Account and Ride Details */}
        <DetailsSection title="Bank Account and Ride Details">
          <DetailRow label="Account Holder" value={data?.account_holder} />
          <DetailRow label="Bank Name" value={data?.bank_name} />
          <DetailRow label="Account Number" value={data?.account_number} />
          <DetailRow label="Bank IFSC Code" value={data?.ifsc_code} />
          <DetailRow label="Aadhaar Number" value={data?.aadhaar_number} />
          <DetailRow label="Total Rides" value={data?.total_rides} />
          <DetailRow label="Cancelled Rides" value={data?.cancel_rides} />
          <DetailRow label="Total Earnings" value={`₹${data?.total_amount}`} />
        </DetailsSection>

        {/* Driver Docuemnt */}
        <DetailsSection title="Driver Car Documents">
          <div className="mt-4">
            <div className="text-lg font-semibold text-gray-700">
              Car Insurance:
            </div>
            <div className="mt-2">
              <img
                src={data?.car_insurance_originalname}
                alt="Insurance"
                className="w-full h-64 object-cover rounded-lg shadow-md transition-all duration-500 ease-in-out hover:scale-105"
              />
            </div>
          </div>

          {/* Licence */}
          <div className="mt-4">
            <div className="text-lg font-semibold text-gray-700">Licence:</div>
            <div className="mt-2">
              <img
                src={data?.licence_originalname}
                alt="Licence"
                className="w-full h-64 object-cover rounded-lg shadow-md transition-all duration-500 ease-in-out hover:scale-105"
              />
            </div>
          </div>

          {/* Registration Certificate */}
          <div className="mt-4">
            <div className="text-lg font-semibold text-gray-700">
              Registration Number:
            </div>
            <div className="mt-2">
              <img
                src={data?.rc_originalname}
                alt="Registration Certificate"
                className="w-full h-64 object-cover rounded-lg shadow-md transition-all duration-500 ease-in-out hover:scale-105"
              />
            </div>
          </div>
        </DetailsSection>

        {/* Vehicle Details */}
        <DetailsSection title="Vehicle Details">
          <DetailRow label="Car Name" value={data?.car_name} />
          <DetailRow label="Car Type" value={data?.car_type} />
          <DetailRow label="Car Number" value={data?.car_number} />

          <DetailRow
            label="Insurance Expiry"
            value={formatDate(data?.insuranceexpiry)}
          />
          {/* <DetailRow label="Car Images"></DetailRow> */}
        </DetailsSection>

        <ImageSlider images={data?.car_images} />

        {/* Action Buttons */}
        <div className="max-w-5xl mx-auto mt-8 flex justify-end space-x-4">
          <button
            onClick={() => Reject(data)}
            className="px-10 py-3 flex flex-row gap-3 bg-red-500 text-white text-lg font-Poppins font-medium rounded-lg shadow hover:bg-red-400 transition duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                clipRule="evenodd"
              />
            </svg>
            Reject
          </button>
          <button
            onClick={() => {
              handleApprove(data);
              close(false);
            }}
            className="px-10 py-3 flex flex-row gap-3 bg-green-500 text-white text-lg font-Poppins font-medium rounded-lg shadow hover:bg-green-400 transition duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                clipRule="evenodd"
              />
            </svg>
            Approve
          </button>
        </div>
      </div>
    </Dialog>
  );
}

function DetailsSection({ title, children }) {
  return (
    <div className="max-w-5xl mx-auto mt-3 bg-white shadow-xl font-Poppins rounded-xl p-8">
      <h3 className="text-2xl font-bold text-gray-800 border-b pb-3">
        {title}
      </h3>
      <div className="grid grid-cols-2 gap-6 mt-6">{children}</div>
    </div>
  );
}

function DetailRow({ label, value, children }) {
  return (
    <div className="flex items-center px-2 py-2 bg-[#f1f1f1] rounded-sm">
      <div className="w-1/2 ">
        <p className="text-sm font-semibold font-Poppins text-gray-800">
          {label}:
        </p>
      </div>
      <div className="w-2/3 px-4">
        {value ? (
          <p className="text-gray-700 font-Poppins text-base">{value}</p>
        ) : (
          <div className="mt-2">{children}</div>
        )}
      </div>
    </div>
  );
}

function ImageSlider({ images }) {
  return (
    <div className=" w-full max-w-5xl mx-auto mt-3 bg-white shadow-xl rounded-xl p-5">
      <h3 className="text-2xl font-bold font-Poppins text-gray-800 border-b pb-3">
        Car Images
      </h3>

      <div className="flex flex-row flex-wrap py-2">
        {images?.map((item, index) => (
          <div key={index} className="w-56 h-64 m-2">
            <img
              src={item}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover rounded-md"
            />
          </div>
        ))}
      </div>

      {/* <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex}`}
        className="w-full h-64 object-cover rounded-t-lg transition-all duration-500 ease-in-out"
      /> */}
      {/* <button
        onClick={handlePrevious}
        className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 transition duration-300"
      >
        &lt;
      </button>
      <button
        onClick={handleNext}
        className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 transition duration-300"
      >
        &gt;
      </button> */}
    </div>
  );
}

function formatDate(date) {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
